import React, { useEffect } from "react";
import PrivateChatContainer from "../../../../Components/Applications/Chat/PrivateChat";
import { useLocation } from "react-router-dom";

export default function ChatPopup() {
  const location = useLocation();

  useEffect(() => {
    if (location.pathname === "/chat-popup") {
      import("../../../../Components/Applications/Chat/popup-site.css")
        .then(() => {
          console.log("Popup CSS loaded.");
        })
        .catch((error) => {
          console.error("Error loading popup CSS:", error);
        });
    }
  }, [location]);
  return <PrivateChatContainer />;
}
